import { createAction, props } from "@ngrx/store";
import {
  Entrada,
  ICancelarEntregable,
  IContador,
  IDespacho,
  Informativo,
  INuevoTemaDespacho,
  IQuitarTema,
  IResDespacho,
  ITemaEliminado,
  ITerminarEntregable,
  ITerminarSeguimiento,
  VoBo,
} from "../../interfaces/despacho";
import {
  ITerminarTemaDespacho,
  ITerminarTemaDespachoNotificacion,
} from "../../interfaces/acuerdos";
import { FormGroup } from "@angular/forms";

export const consultarDespachos = createAction(
  "[Table-despacho] consultar despachos"
);
export const consultarDespachosSuccess = createAction(
  "[Table-despacho] consultar Despachos Success",
  props<{ despachos: IDespacho[] }>()
);
export const consultarDespachosFail = createAction(
  "[Table-despacho] consultar Despachos Fail"
);

export const seleccionarDespacho = createAction(
  "[Table-despacho] seleccionar Despacho",
  props<{ despacho: IDespacho }>()
);
export const seleccionarTipoDespacho = createAction(
  "[Table-despacho] seleccionarTipoDespacho"
);

export const isDespachoSelected = createAction(
  "[Table-despacho] is Despacho Selected",
  props<{ despacho: IDespacho }>()
);
export const setEntradasByEmpresa = createAction(
  "[Table-despacho] get Entradas By Empresa ",
  props<{ entradas: Entrada[] }>()
);
export const setEntradasByEmpresaSuccess = createAction(
  "[Table-despacho] get Entradas By Empresa ",
  props<{ entradas: Entrada[] }>()
);
;

export const consultarEntradasPorEmpresa = createAction(
  "[Table-despacho] consultar Entradas Por Empresa",
  props<{ entradas: Entrada[] }>()
);

export const setEntradasEmpresaAndDespacho = createAction(
  "[Table-despacho] set Entradas Empresa And Despacho detalle",
  props<{ despacho: IDespacho; entradas: Entrada[] }>()
);

export const validarTemasDespacho = createAction(
  "[Table-despacho] validar Temas Despacho"
);

export const saveTemasDespacho = createAction(
  "[Table-despacho] save Temas Despacho"
);
export const saveTemasDespachoSuccess = createAction(
  "[Table-despacho] save Temas Despacho Success"
);
export const saveTemasDespachoFailure = createAction(
  "[Table-despacho] save Temas Despacho Failure"
);

export const updateTemaDespacho = createAction(
  "[Table-despacho] update Tema Despacho",
  props<{ tipoTema: string; temas: Informativo[] | VoBo[] }>()
);
export const updateTemaMarcarImprimir = createAction(
  "[Table-despacho] update TemaMarcar Imprimir",
  props<{ tema: { tema_id: string; marcarParaIImpresion: boolean } }>()
);

export const enviarNotificacionTemas = createAction(
  "[Table-despacho] enviar Notificacion Temas"
);
export const enviarNotificacionTemasSuccess = createAction(
  "[Table-despacho] enviar Notificacion Temas Success"
);
export const enviarNotificacionTemasFailure = createAction(
  "[Table-despacho] enviar Notificacion Temas Failure"
);

//acciones despacho
export const quitarTemaNotificarDespacho = createAction(
  "[QuitarTemaComponent] quitar Tema Despacho - Notificar despacho",
  props<{ quitarTema: IQuitarTema; temaEliminado: ITemaEliminado }>()
);
export const cancelarEntregableDespacho = createAction(
  "[CancelarEntregableComponent] cancelar Entregable Despacho",
  props<{ entregable: ICancelarEntregable }>()
);
export const terminarSeguimientoDespacho = createAction(
  "[Terminar Seguimiento Component] terminar Seguimiento Despacho",
  props<{ seguimiento: ITerminarSeguimiento }>()
);
export const terminarEntregablesDespacho = createAction(
  "[Terminar Entregables Component] terminar Entregables Despacho",
  props<{ entregables: ITerminarEntregable }>()
);
//error en acciones despacho
export const ejeccionAccionDespachoError = createAction(
  "[Table-despacho]ejeccion Accion Despacho Error"
);
//success en acciones despacho
export const ejeccionAccionDespachoSuccess = createAction(
  "[Table-despacho]ejeccion Accion Despacho Success"
);

export const getEntradasByIdEmpresa = createAction(
  "[Nuevo Tema Despacho] get Entradas By IdEmpresa",
  props<{ idEmpresa: string }>()
);
export const getEntradasByIdEmpresaSuccess = createAction(
  "[Nuevo Tema Despacho] get Entradas By IdEmpresa Success",
  props<{ entradas: Entrada[] }>()
);

export const getEntradasByIdEmpresaError = createAction(
  "[Nuevo Tema Despacho] get Entradas By IdEmpresa Error"
);

export const esNuevoDespacho = createAction(
  "[Nuevo Tema Despacho] esNuevoTema"
);

export const guardarNuevoDespacho = createAction(
  "[Nuevo Tema Despacho] guardarNuevoDespacho",
  props<{ despacho: INuevoTemaDespacho }>()
);

export const enviarNotificacionDespacho = createAction(
  "[Nuevo Tema Despacho] enviarNotificacionDespacho",
  props<{ despacho: INuevoTemaDespacho }>()
);

export const guardarFormulariosInfoVobo = createAction(
  "[Nuevo Tema Despacho] guardarFormulariosInfoVobo",
  props<{ form: any }>()
);

export const getFormulariosInfoVobo = createAction(
  "[Nuevo Tema Despacho] getFormulariosInfoVobo",
  props<{ temas: any }>()
);

export const updateDespacho = createAction(
  "[Nuevo Tema Despacho] updateDespacho",
  props<{ vobo: any; informativo: any; id_empresa: string }>()
);

export const guardarNuevoDespachoFail = createAction(
  "[Nuevo Tema Despacho] guardarNuevoDespachoFail"
);
export const guardarNuevoDespachoSuccess = createAction(
  "[Nuevo Tema Despacho] guardarNuevoDespachoSuccess"
);

export const setContador = createAction("[Nuevo Tema Despacho] setContador");

export const setContadorSuccess = createAction(
  "[Nuevo Tema Despacho] setContadorSuccess",
  props<{
    contador: IContador;
  }>()
);

export const setContadorByAcuerdo = createAction(
  "[Nuevo Tema Despacho] setContadorByAcuerdo",
  props<{
    infoDespacho:any,
    tipoAcuerdo:number
  }>()
);

export const terminarTemaDespacho = createAction(
  "[TerminarTema Component] terminarTemaDespacho",
  props<{
    temaDespacho: ITerminarTemaDespacho;
    temaTerminado: ITerminarTemaDespachoNotificacion;
  }>()
);

export const terminarTemaDespachoSuccess = createAction(
  "[TerminarTema Component] terminarTemaDespachoSuccess"
);

export const terminarTemaDespachoFail = createAction(
  "[TerminarTema Component] terminarTemaDespachoFail"
);

export const resetEntradasMoverMrb = createAction(
  "[TerminarTema Component] resetEntradasMoverMrb"
);

export const expandedTipoDespacho = createAction(
  "[TerminarTema Component] expandedTipoDespacho",
  props<{
    currentExpanded: string;
  }>()
);

export const updateCurrentDespacho = createAction(
  "[Table-despacho] updateCurrentDespacho",
  props<{ despacho: IDespacho }>()
);
export const updateStatusDespacho = createAction(
  "[Table-despacho] updateStatusDespacho",
  props<{ status: string }>()
);
export const resetDespacho = createAction("[Table-despacho] reset despacho");
